import {
  UsageExplorerFeatureFlagName,
  UsageExplorerFeatureFlagsResponse,
} from "@shared/types/localTypes/usage-explorer.ts";

type UsageExplorerFeatureFlags =
  () => Promise<UsageExplorerFeatureFlagsResponse>;

const TOUR_FEATURE_FLAGS = [
  "storage_breakdown",
] as const satisfies ReadonlyArray<UsageExplorerFeatureFlagName>;

const usageExplorerFeatureFlags: UsageExplorerFeatureFlags = async () => ({
  feature_flags: [...TOUR_FEATURE_FLAGS],
});

export default usageExplorerFeatureFlags;
